import { render, staticRenderFns } from "./app-select.vue?vue&type=template&id=2c67c2b1&"
import script from "./app-select.vue?vue&type=script&lang=js&"
export * from "./app-select.vue?vue&type=script&lang=js&"
import style0 from "./app-select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports